<script>
  import { _ } from 'svelte-i18n';

  import { api } from "./../libs/api.js";

  export let mod;

  let isSaving = undefined;

  async function submitData(ev) {
    isSaving = api.submit_results(mod.id, JSON.stringify(mod.exercises));
  }
</script>

<div class="relative z-20">

  {#if isSaving === undefined}
    <button class="btn btn-primary" on:click="{submitData}">
      {$_('course.save')}
    </button>
  {:else}
    {#await isSaving}
      <span class="btn btn-primary loading">
        {$_('course.saving')}
      </span>
    {:then name}
      <span class="btn btn-success">
        {$_('course.done')}
      </span>
    {/await}
  {/if}

</div>